import { useState } from "react";

import { usersService } from "../../../services/users-service";
import { systemsService } from "../../../services/systems-service";
import { systemGroupsService } from "../../../services/system-groups-service";
import { risksService } from "../../../services/risks-service";
import { functionsService } from "../../../services/functions-service";
import { matrixService } from "../../../services/matrix-service";
import { criticalRuleService } from "../../../services/critical-rule-service";
import { customRolesService } from "../../../services/custom-roles-service";
import { busynessProcessesService } from "../../../services/busyness-processes-service";
import { adminService } from "../../../services/admin-service";
import { compensationProceduresService } from "../../../services/compensation-procedures-service";

const useLogs = (entity, key) => {
    const [logs, setLogs] = useState([]);
    const [total, setTotal] = useState(0);
    const [openLogs, setOpenLogs] = useState(false);
    const [pageNumber, setPageNumber] = useState(1);
    const [limitNumber, setLimitNumber] = useState(10);

    const getLogs = async (page = pageNumber, limit = limitNumber) => {
        const validPage = typeof page === "object" ? pageNumber : Number(page);
        const validLimit = typeof limit === "object" ? limitNumber : Number(limit);

        if (!openLogs) {
            setOpenLogs(true);
        }

        const result = await getChangeHistory(validPage, validLimit);

        setLogs(result?.logs || []);
        setTotal(result?.total || 0);
    };
    const clearLogs = () => {
        setLogs([]);
        setTotal(0);
        setPageNumber(1);
    };

    const getChangeHistory = async (page, limit) => {
        const params = { page: page, limit: limit };

        switch (entity) {
            case "system":
                return await systemsService.getSystemChangeHistory(key, params);
            case "system_group":
                return await systemGroupsService.getGroupChangeHistory(key, params);
            case "user":
                return await usersService.getUserChangeHistory(key, params);
            case "risk":
                return await risksService.getRiskChangeHistory(key, params);
            case "matrix":
                return await matrixService.getMatrixHeaderChangeHistory(key, params);
            case "function":
                return await functionsService.getFunctionChangeHistory(key, params);
            case "critical_role":
                return await criticalRuleService.getCriticalRoleChangeHistory(key, params);
            case "critical_profile":
                return await criticalRuleService.getCriticalProfileChangeHistory(key, params);
            case "custom_role":
                return await customRolesService.getCustomRoleChangeHistory(key, params);
            case "busynessProcess":
                return await busynessProcessesService.getBusynessProcessChangeHistory(key, params);
            case "compensationProcedure":
                return await compensationProceduresService.getCompensationProcedureChangeHistory(key, params);
            case "core-settings":
                return await adminService.getCoreSettingsLogs(params);
            case "sod-settings":
                return await adminService.getSodSettingsLogs(params);
        }
    };

    const handlePageChange = (newPage) => {
        setPageNumber(newPage);
        getLogs(newPage, limitNumber);
    };

    const handleLimitChange = (newLimit) => {
        setLimitNumber(newLimit);
        setPageNumber(1);
        getLogs(1, newLimit);
    };

    return {
        logs,
        total,
        setLogs,
        getLogs,
        clearLogs,
        openLogs,
        setOpenLogs,
        pageNumber,
        setPageNumber: handlePageChange,
        limitNumber,
        setLimitNumber: handleLimitChange,
    };
};

export default useLogs;
